import {TIPOS_NIVELES, LOADING_TIPOS_NIVELES, SELECTED_TIPOS_NIVEL} from './../types';
import {AppEnv} from '../../../components/env';
import axios from 'axios';
import Functions from '../../../components/Global/Functions';

const apiUrl = AppEnv.api;

export function setLoading(data) {
    return {
        type: LOADING_TIPOS_NIVELES,
        payload: data
    };
}

export function createTipoNivel(token, country,nivel, fd) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.post(apiUrl + 'tipo/niveles/create', fd, {
                method: 'post', headers: {
                    Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            Functions.alertSuccess();
            dispatch(fetchTipoNiveles(token, country,nivel));
        }).catch(error => {
            Functions.alertFail();
            dispatch(fetchTipoNiveles(token, country,nivel));
        });
    };
}

export function fetchTipoNiveles(token, country,nivel) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.get(apiUrl + 'tipo/niveles/get/' + country+'/' + nivel, {
                method: 'get', headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            dispatch(fetchTipoNivelesSuccess(response.data));
        }).catch(error => {
            dispatch(fetchTipoNivelesFailed());
        });
    };
}

export function updateTipoNivel(token, country,nivel, fd, id) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.post(apiUrl + 'tipo/niveles/update/' + id, fd, {
                method: 'post', headers: {
                    Accept: 'application/json, text/plain, */*', 'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            Functions.alertSuccess();
            dispatch(fetchTipoNiveles(token, country,nivel));
        }).catch(error => {
            Functions.alertFail();
            dispatch(fetchTipoNiveles(token, country,nivel));
        });
    };
}

export function deleteTipoNivel(token, country,nivel, id) {
    return (dispatch) => {
        dispatch(setLoading(true));
        axios.get(apiUrl + 'tipo/niveles/delete/' + id, {
                method: 'get', headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: 'Bearer ' + token
                }
            }
        ).then((response) => {
            Functions.alertSuccess();
            dispatch(fetchTipoNiveles(token, country,nivel));
        }).catch(error => {
            Functions.alertFail();
            dispatch(fetchTipoNiveles(token, country,nivel));
        });
    };
}

export function fetchTipoNivelesSuccess(response) {
    return {
        type: TIPOS_NIVELES,
        payload: response
    };
}

export function fetchTipoNivelesFailed() {
    Functions.alertFail();
    return {
        type: TIPOS_NIVELES,
        payload: []
    };
}

export function setTipoNivel(TipoNivel) {
    return {
        type: SELECTED_TIPOS_NIVEL,
        payload: TipoNivel
    };
}